export const AGE_GENDER_SUBJECTS = [
  '10대',
  '20대',
  '30대',
  '40대',
  '50대',
  '60대',
  '60대 초과',
];
